<div class="row">
  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Grado'"
       [valueInput]="ctxBodyFascicolo.fascicolo.grado ? ctxBodyFascicolo.fascicolo.grado.label : ''"></div>
  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Numero/Anno ruolo'"
       [valueInput]="(ctxBodyFascicolo.fascicolo.numeroRuolo ? ctxBodyFascicolo.fascicolo.numeroRuolo : '')  + ((ctxBodyFascicolo.fascicolo.annoRuolo && ctxBodyFascicolo.fascicolo.numeroRuolo) ? '/' : '') + (ctxBodyFascicolo.fascicolo.annoRuolo ? ctxBodyFascicolo.fascicolo.annoRuolo : '')"></div>
  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Processo telematico'"
       [valueInput]="ctxBodyFascicolo.fascicolo.flagProcessoTelematico ? 'Si' : 'No'"></div>
</div>
<ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila || ctxBodyFascicolo.fascicolo.riunito">
  <div class="row container_fieldset">
    <fieldset class="form-group">
      <legend>Riunione dei giudizi</legend>
      <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila">
        <div labelTextInput class="col-sm-4 bloccodati"
             [typeLabel]="'text'" [labelInput]="'Capofila'"
             [valueInput]="ctxBodyFascicolo.fascicolo.capofila ? 'Si' : 'No'"></div>
      </ng-template>
      <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.riunito">
        <div labelTextInput class="col-sm-4 bloccodati"
             [typeLabel]="'text'" [labelInput]="'Riunito'"
             [valueInput]="ctxBodyFascicolo.fascicolo.riunito ? 'Si' : 'No'"></div>
      </ng-template>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data riunione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataRiunioneGiudizio"></div>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Motivo riunione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.motivoRiunioneGiudizio"></div>
    </fieldset>
  </div>
</ng-template>

<div class="row container_fieldset">
  <fieldset class="form-group">
    <legend>Fascicolo opposto</legend>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Posizione'"
         [valueInput]="ctxBodyFascicolo.fascicolo.posizioneFascicoloRif"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
         [labelInput]="'N&deg; ruolo/decreto'"
         [valueInput]="ctxBodyFascicolo.fascicolo.numRuoloDecretoRif"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data apertura'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataInizioFascicoloRif"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'importo'"
         [labelInput]="'Valore'"
         [valueInput]="ctxBodyFascicolo.fascicolo.valoreFascicoloRif"></div>
  </fieldset>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Motivo opposizione</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.motivoOpposizione }}</span>
    </p>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>

<div class="row container_fieldset">
  <fieldset>
    <legend>Fascicolo di riferimento</legend>
    <div labelTextInput class="col-sm-4 bloccodati"
         [typeLabel]="'text'" [labelInput]="'N&deg; ruolo / decreto'"
         [valueInput]="ctxBodyFascicolo.fascicolo.numRuoloDecretoRif"></div>
    <div labelTextInput class="col-sm-4 bloccodati"
         [typeLabel]="'date'" [labelInput]="'Data apertura fascicolo'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataInizioFascicoloRif"></div>
    <div labelTextInput class="col-sm-4 bloccodati"
         [typeLabel]="'text'" [labelInput]="'Posizione Teleforum'"
         [valueInput]="ctxBodyFascicolo.fascicolo.posizioneFascicoloRif"></div>

  </fieldset>
</div>
